import { gql } from '@apollo/client';

export const GET_COMPANY_LIST_CREATOR_FLAG = gql`
    query Query {
        userCompanyListWithCreatorFlag {
            _id
            legalBusinessName
            companyLogo
            hasCreatedCompany
            userId
            isInviteTeamSkipped
            isLocked
        }
    }
`;

export const GET_COMPANY_LIST_CREATOR_FLAG_EXTENSION = gql`
    query Query {
        userCompanyListWithCreatorFlagExtension {
            _id
            legalBusinessName
            companyLogo
            hasCreatedCompany
            userId
            isInviteTeamSkipped
            isLocked
        }
    }
`;

export const GET_AUTHORIZED_USERS = gql`
    query GetAuthorizedUsers {
        getAuthorizedUsers {
            users {
                email
                firstName
                lastName
                userId
            }
        }
    }
`;

export const GET_AUTHORIZED_USERS_INITIAL = gql`
    query GetAuthorizedUsersInitial($companyIds: [String!]!) {
        getAuthorizedUsersInitial(companyIds: $companyIds) {
            companyId
            data
        }
    }
`;

export const GET_AUTHORIZED_COMPANY = gql`
    query GetAuthorizedCompany($companyId: String!, $email: String!) {
        getAuthorizedCompany(companyId: $companyId, email: $email) {
            hasSetup
            hasPermission
            success
        }
    }
`;

export const FETCH_NON_USER_COMPANY = gql`
    query FindNonUserCompany($email: String!) {
        findNonUserCompany(email: $email) {
            companyDetails {
                _id
                legalBusinessName
                companyLogo
                userId
            }
        }
    }
`;
